import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { IReviewProps, moneyParse } from "../ReviewParser";

export const AdHocAdviserChargeReview = (props: IReviewProps) => {
    const { data, onEditAction } = props;

    const adviceCahrgeConfig = () => {
        if (!data) {return [];}
        const defaultFormatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(0), CurrencyCode.GBP);
        const config = [
            {
                title: "Additional adviser charge",
                data: data?.AdHocAdviserCharge?.Amount ? moneyParse(data?.AdHocAdviserCharge?.Amount) : defaultFormatMoney,
            },
            {
                title: "Include other product Ongoing adviser charge",
                data: data?.OngoingAdviserChargeInstructions?.length > 0 ? "Yes" : "No",
            },
        ];
        return config;
    };

    return (
        <Accordion label="Additional adviser charge" isOpen={false} onEdit={() => onEditAction()}>
            <div className="pl-34">
                <Typography type="common" config={adviceCahrgeConfig()}></Typography>
            </div>
        </Accordion>
    );
};
